<template>
    <div>
        <div class="flex jcbc p14-9">

            <div class="flex w66 alc">
                <el-select v-model="isuse" size="mini" @change="searchFun" style="margin-right: 9px; width: 100px">
                    <el-option v-for="item in isuseList" :key="item.key" :label="item.label" :value="item.key"></el-option>
                </el-select>
                <el-select v-model="i_pid" filterable clearable @change="searchFun" :remote="true"
                           :remote-method="jtgssearch"  size="mini" style="margin-right: 9px;width: 150px">
                    <el-option v-for="item in jtgsList" :key="item.i_id" :label="item.vc_name" :value="item.i_id"></el-option>
                </el-select>
                <el-input  class="marr4" style="width:200px"  v-model="vc_search" :placeholder="$t('companyManageMD_please_enter_the_company_name')" clearable size="mini"></el-input>
                <el-button class="marr4" icon="el-icon-search" circle  @click="searchFun" size="mini"></el-button>
            </div>
            <el-button class="marB10" @click="addFun" :class="baseerp+'btn'" size="mini">
                新增
            </el-button>
        </div>

        <el-table
                class="mrt10" ref="table" size="mini" :height="tableHeight" border :data="tableData"
                :header-cell-style="{background:'#eef1f6',color:'#000'}" :highlight-current-row="true" style="width: 100%">
            <el-table-column type="index" :label="$t('form_serial_number')"></el-table-column>
            <el-table-column  prop="i_id" :label="$t('companyManageMD_company_id')" show-overflow-tooltip></el-table-column>
            <el-table-column  prop="vc_creditcode" :label="$t('companyManageMD_enterprise_code')" show-overflow-tooltip></el-table-column>
            <el-table-column  prop="vc_name" :label="$t('form_corporate_name')" show-overflow-tooltip></el-table-column>
            <el-table-column  prop="vc_enamefull" :label="$t('companyManageMD_english_full_name')" show-overflow-tooltip></el-table-column>
            <el-table-column  prop="vc_sname" :label="$t('companyManageMD_company_abbreviation')" show-overflow-tooltip></el-table-column>
            <el-table-column  prop="vc_ename" :label="$t('companyManageMD_contract_identifier')" show-overflow-tooltip></el-table-column>
<!--            <el-table-column  prop="i_order" :label="$t('companyManageMD_serial_number')" show-overflow-tooltip></el-table-column>-->
<!--            <el-table-column  prop="vc_methodName" label="本位币币种" show-overflow-tooltip></el-table-column>-->
            <el-table-column  prop="vc_fr" :label="$t('companyManageMD_legal_person')" show-overflow-tooltip></el-table-column>
<!--            <el-table-column  prop="vc_gstel" :label="$t('companyManageMD_company_office_number')" show-overflow-tooltip></el-table-column>-->
            <el-table-column  prop="vc_sign" :label="$t('companyManageMD_company_signature')" show-overflow-tooltip></el-table-column>
            <el-table-column  prop="isuse" :label="$t('companyManageMD_enable_or_not')" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span>{{scope.row.isuse==1?$t('form_correct'):$t('form_deny')}}</span>
                </template>
            </el-table-column>
            <el-table-column  prop="i_canpresold" :label="$t('companyManageMD_can_it_be_pre_sold')" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span>{{scope.row.i_canpresold==1?$t('companyManageMD_can'):$t('companyManageMD_cannot')}}</span>
                </template>
            </el-table-column>
            <el-table-column  prop="i_type" :label="$t('companyManageMD_company_type')" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span v-if="scope.row.i_type==0">{{$t('companyManageMD_trading_companies')}}</span>
                    <span v-if="scope.row.i_type==1">{{$t('companyManageMD_entrusted_company')}}</span>
                    <span v-if="scope.row.i_type==2">{{$t('companyManageMD_trade+production_company_(including_filling_business)')}}</span>
                </template>
            </el-table-column>
<!--            <el-table-column  prop="vc_fax" :label="$t('companyManageMD_fax')" show-overflow-tooltip></el-table-column>-->
<!--            <el-table-column  prop="vc_kftel" label="客服" show-overflow-tooltip></el-table-column>-->
            <el-table-column  prop="vc_address" :label="$t('companyManageMD_company_registered_address')" show-overflow-tooltip></el-table-column>
            <el-table-column  prop="vc_eaddress" :label="$t('companyManageMD_english_registered_address')" show-overflow-tooltip></el-table-column>
            <el-table-column  prop="i_dsid" :label="$t('companyManageMD_e-commerce_id')" show-overflow-tooltip></el-table-column>
            <el-table-column  prop="i_khid" :label="$t('companyManageMD_associate_customer_id')" show-overflow-tooltip></el-table-column>
            <el-table-column  prop="vc_plat" :label="$t('companyManageMD_attribution_system')" show-overflow-tooltip></el-table-column>
            <el-table-column  prop="vc_pname" :label="$t('companyManageMD_group_company')" show-overflow-tooltip></el-table-column>
            <el-table-column  prop="vc_national" :label="$t('companyManageMD_country')" show-overflow-tooltip></el-table-column>
            <el-table-column  prop="vc_bzname" :label="$t('companyManageMD_local_currency')" show-overflow-tooltip></el-table-column>
            <el-table-column  prop="vc_lruname" :label="$t('form_input_person')" show-overflow-tooltip></el-table-column>
            <el-table-column  prop="dt_createtime" :label="$t('form_enter_time')" show-overflow-tooltip></el-table-column>
            <el-table-column :label="$t('form_operate')" width="120" align="center">
                <template slot-scope="scope">
                    <el-button  size="mini" type="text" @click="detailsFun(scope.row)" >{{$t('companyManageMD_details')}}</el-button>
                    <el-button  size="mini" type="text" @click="yinHang(scope.row)" >{{$t('companyManageMD_bank_information')}}</el-button>

                </template>
            </el-table-column>
        </el-table>
        <el-pagination  style="margin-top: 10px;text-align: right" background @current-change="pageCurrentChange" layout="total,prev, pager, next"
                        :current-page.sync="currentPage" :total="total" :page-size="pageSize">
        </el-pagination>
        <div :class="baseerp+'div'">
            <el-dialog :title="$t('companyManageMD_bank_information')" width="95%" top="30px" :visible.sync="dialogBankVisible"
                       :close-on-click-modal="false" @close="closeyinHangFun">
                <bank-list :data="bankProp" v-if="dialogBankVisible" @close="closeyinHangFun"></bank-list>
            </el-dialog>
        </div>
        <div :class="baseerp+'div'">
            <el-dialog :title="gstitle" width="95%"  :visible.sync="dialogGsVisible" top="10px"
                       :close-on-click-modal="false" @close="closeGsFun">
                <gs-page :data="gsProp" v-if="dialogGsVisible" @close="closeGsFun"></gs-page>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp, baseApp, file_url, baseVersion} from "@/utils/baseUrl";
    import BankList from "./BankList";
    import GsPage from "./GsPage";

    export default {
        name: "index",
        components: {BankList,GsPage},
        props: {},
        data() {
            return {
                tableHeight: 0,
                baseerp: '',
                tableData:[],
                currentPage:1,
                pageSize:20,
                total:0,
                dialogBankVisible:false,
                dialogGsVisible:false,
                bankProp:{},
                gsProp:{},
                gstitle:'',
                isuseList:[{key:0,label:this.$t('state_disabled')},{key:1,label:this.$t('state_enabled')}],
                isuse:1,
                vc_search:'',
                jtgsList:[],
                jtgs_search:'',
                i_pid:'',
            }
        },
        watch: {
            '$root.workSize': {
                handler(n, o) {
                    this.onResize(n);
                },
                deep: true,
            },
        },
        activated() {
            this.onResize();
        },
        mounted() {
            this.baseerp = baseerp;
            this.$nextTick(() => {
                this.onResize();
            })
            this.getCompanyList()
            this.getGroupCompanyList()
        },
        methods: {
            onResize(n) {
                if (n == undefined) n = this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight = n.h - (n.h) * 0.2;
                if (this.tableHeight < 60) this.tableHeight = 60;
            },
            searchFun(){
                this.currentPage=1
                this.getCompanyList()
            },
            addFun(){
                this.dialogGsVisible=true;
                this.gstitle=this.$t('companyManageMD_add_company');
                this.gsProp={
                    i_id:0
                }
            },
            detailsFun(val){
                this.dialogGsVisible=true;
                this.gstitle=this.$t('companyManageMD_editing_company');
                this.gsProp=val
            },
            yinHang(val){
                this.dialogBankVisible=true;
                this.bankProp={
                    i_id:val.i_id,
                    vc_name:val.vc_name
                };
            },
            closeyinHangFun(){
                this.bankProp=null
                this.dialogBankVisible=false;
            },
            closeGsFun(type='back'){
                this.dialogGsVisible=false;
                if(type=='save'){
                    this.currentPage=1
                    this.getCompanyList()
                }
                this.gsProp=null
            },
            pageCurrentChange(val){
                this.currentPage=val;
                this.getCompanyList()
            },
            async getCompanyList(){
                let param={
                    isuse:this.isuse,
                    vc_search:this.vc_search,
                    pageSize: 20,
                    currentPage:this.currentPage,
                    i_pid:this.i_pid
                };
                let res=await API.getCompanyList(param);
                if ( res.code == 1 ){
                    this.tableData=res.data.companyList;
                    this.total=res.data.total;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            jtgssearch(val){
                this.jtgs_search=val;
                this.getGroupCompanyList();
            },
            //集团公司
            async getGroupCompanyList(){
                let param={
                    vc_search:this.jtgs_search
                };
                let res=await API.getGroupCompanyList(param);
                if ( res.code == 1 ){
                    this.jtgsList=res.data;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .flex{
        display: flex;
    }
    .jcbc{
        justify-content: space-between;
    }
    .p14-9{
        padding: 14px 9px;
    }
</style>